import { getFunctionBaseUrl } from './RestUrls';
import * as rest from './RestUtil';
export interface IReportSchedule {
  type: number;
  month: string;
  dayOfMonth: number;
  hour: number;
  minute: number;
}
export interface IReportParameters {
  operatorId: string;
  autogenReport: boolean;
  autogenEmail: boolean;
}
export interface IManualReportParameters {
  reportPeriod: string;
  reportLanguage: string;
  reports: IReportParameters[];
}
export interface IReportMailStatus {
  status: string;
  info: string;
  time: string;
}
export interface ILastReport {
  reportId: string;
  generatedDate: string;
  periodStart: string;
  periodEnd: string;
  autoGenerated: boolean;
  success: boolean;
  empty: boolean;
  info: string;
  mailStatus: IReportMailStatus;
}
export interface IListReportParameters extends IReportParameters {
  operatorName: string;
  lastReport: ILastReport | null;
}

export class ReportSchedules {
  monthly!: IReportSchedule;
  quarterly!: IReportSchedule;
  yearly!: IReportSchedule;
}

export const getReportParameters = async () => {
  const url = `${getFunctionBaseUrl()}/api/reportParams`;
  const response = await rest.get(url);
  return response as IListReportParameters[];
}

export const getReportSchedules = async () => {
  const url = `${getFunctionBaseUrl()}/api/reportSchedule`;
  const response = await rest.get(url);
  return response as ReportSchedules;
}

export const saveReportParameters = async (params: IReportParameters) => {
  const url = `${getFunctionBaseUrl()}/api/reportParams`;
  const response = await rest.put(url, params);
  return response;
}

export const saveReportSchedule = async (schedule: IReportSchedule) => {
  const url = `${getFunctionBaseUrl()}/api/reportSchedule`;
  const response = await rest.put(url, schedule);
  return response;
}

export const makeManualReports = async (reports: IManualReportParameters) => {
  const url = `${getFunctionBaseUrl()}/api/GenerateReceptionReports`;
  const response = await rest.put(url, reports);
  return response;
}